import request from '@/api/request';
const notificationRequest = request(process.env.NOTIFICATION_API);

export function SendMessage (data) {
  return notificationRequest({
    url: 'sendwebhook',
    method: 'post',
    data
  });
}

export function GetNotifications (params) {
  return notificationRequest({
    url: 'get_notifications',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/notification.js